module.exports = __webpack_public_path__ + "assets/img/bp_d_i_12.61f1ec58.jpg";